<script setup lang="ts">
import { ref, onMounted } from 'vue';
import Swal from 'sweetalert2';

const newsStore = useNewsStore();
const userStore = useUserStore();
const route = useRoute();

const banners = ref<any[]>([]); // Gunakan tipe array untuk banners

const getBanner = async () => {
  try {
    const response: any = await newsStore.getBanner();
    if (response.status.code == 200) {
      banners.value = response.details.data;
    }
  } catch (error) {
    console.error(error);
  }
};

const verifyClientToken = async () => {
  const clientToken = route.query.client_token as string;
  const id = route.query.id;

  if (clientToken && id) {
    try {
      const response: any = await userStore.verifyTokenClient(clientToken, id);
      // if (response.status.code === 200) {
      //   window.close();
      // }
    } catch (error) {
      // Swal.fire("Error", error.message, "error");
      // window.close();
      console.error(error);
    }
  }
};

onMounted(() => {
  verifyClientToken();
  getBanner();
  // watch(() => userStore.token, (newToken) => {
  //   if (newToken) {
  //   }
  // }, { immediate: true })
});
</script>
<template>
  <NuxtLayout name="dashboard">
    <div class="background">
      <div class="header-image header-image-sm">
        <h1 class="fw-bold">Pergi kemana hari ini?</h1>
      </div>
      <div class="card-transaksi-wrapper">
        <CardTransaksi />
      </div>
    </div>
    <div class="container">
      <div class="row mt-1 justify-content-center">
          <div class="col-8" v-if="banners.length > 0">
            <div
                v-if="banners.length > 0"
                id="carouselFasilitasHotel"
                class="carousel slide rounded rounded-4 rounded-top my-2"
                data-bs-ride="carousel"
              >
                <div class="carousel-indicators">
                  <button
                    v-for="(img, index) in banners"
                    :key="index"
                    type="button"
                    data-bs-target="#carouselFasilitasHotel"
                    :data-bs-slide-to="index"
                    :class="{ active: index === 0 }"
                    aria-current="true"
                    aria-label="Slide {{ index + 1 }}"
                  ></button>
                </div>
                <div class="carousel-inner">
                  <div
                    v-for="(image, index) in banners"
                    :key="index"
                    :class="{ 'carousel-item': true, active: index === 0 }"
                  >
                    <img 
                      :src="image.url_banner" 
                      class="d-block w-100 rounded rounded-4 rounded-top banner-img"
                      alt="Banner Image"
                    />
                  </div>
                </div>
                <button
                  class="carousel-control-prev custom-carousel-btn"
                  type="button"
                  data-bs-target="#carouselFasilitasHotel"
                  data-bs-slide="prev"
                >
                  <span class="carousel-control-prev-icon"></span>
                </button>
                <button
                  class="carousel-control-next custom-carousel-btn"
                  type="button"
                  data-bs-target="#carouselFasilitasHotel"
                  data-bs-slide="next"
                >
                  <span class="carousel-control-next-icon"></span>
                </button>
              </div>
          </div>
        </div>
    </div>
  </NuxtLayout>
</template>

<style scoped>
.background {
  position: relative;
  background-color: #fff;
  padding-bottom: 20px; /* Tambahkan padding bawah untuk menghindari tabrakan dengan PreFooter */
}

.header-image {
  height: 70vh;
  background-image: url('https://images.unsplash.com/photo-1507608616759-54f48f0af0ee?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D');
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  text-align: center;
  position: relative;
}

.header-image::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Adjust the alpha (last value) for darkness */
}

.header-image h1 {
  font-size: 2em;
  margin-bottom: 20px;
  z-index: 1;
}

.card-transaksi-wrapper {
  margin-top: -100px;
  margin-bottom: 20px;
}

.banner-img {
  height: auto; /* Atur tinggi tetap */
  width: 75%; /* Pastikan gambar memenuhi lebar */
  object-fit: cover; /* Pastikan gambar tidak terdistorsi */
  border-radius: 10px; /* Opsional: Agar sudutnya tidak terlalu tajam */
}

/* Tombol navigasi dibuat lebih tebal dan berwarna hitam */
.custom-carousel-btn .carousel-control-prev-icon,
.custom-carousel-btn .carousel-control-next-icon {
  background-color: rgba(0, 0, 0, 0.7); /* Warna hitam dengan transparansi */
  border-radius: 50%; /* Buat tombol berbentuk lingkaran */
  padding: 15px; /* Tambah ukuran padding agar lebih tebal */
}

</style>


